import React from 'react';

function Sparkline({ data = [], width = 80, height = 30, color }) {
    if (!data || data.length < 2) {
        return <div style={{ width, height }} className="sparkline-empty" />;
    }

    const min = Math.min(...data);
    const max = Math.max(...data);
    const range = max - min || 1;

    // Normalize data points to fit in the SVG viewbox
    const points = data.map((value, index) => {
        const x = (index / (data.length - 1)) * width;
        const y = height - ((value - min) / range) * (height - 4) - 2;
        return `${x},${y}`;
    }).join(' ');

    // Determine color based on trend (first vs last point)
    const trendColor = color || (data[data.length - 1] >= data[0] ? '#00ff88' : '#ff4444');

    return (
        <svg
            width={width}
            height={height}
            className="sparkline"
            viewBox={`0 0 ${width} ${height}`}
        >
            <polyline
                fill="none"
                stroke={trendColor}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                points={points}
            />
        </svg>
    );
}

export default Sparkline;
